<template>
  <div class="position-relative">
    <a
      href="#"
      class="py-1 px-0 nav-link bord"
      :class="[
        textWhite ? textWhite : 'text-body',
        showLanguageBar ? 'show' : '',
      ]"
      id="dropdownMenuButton"
      data-bs-toggle="dropdown"
      aria-expanded="false"
      @click="showLanguageBar = !showLanguageBar"
    >
      <span class="mx-4 cursor-pointer">
        <img
          :src="findLanguageByCode($i18n.locale).flag"
          class="avatar avatar-sm me-1"
          alt="flag"
        />
        {{ findLanguageByCode($i18n.locale).name }}
      </span>
    </a>
    <ul
      class="ps-md-4 py-3 dropdown-menu dropdown-menu-end me-sm-n4 shad"
      :class="showLanguageBar ? 'show' : ''"
      aria-labelledby="dropdownMenuButton"
    >
      <li
        class="mb-2 back shad w-80"
        v-for="(lang, index) in languages"
        :key="index"
        :value="lang.code"
      >
        <a
          class="dropdown-item border-radius-md"
          href="javascript:;"
          @click="changeLanguage(lang.code)"
        >
          <div class="my-1 d-flex">
            <img :src="lang.flag" class="avatar avatar-sm me-3" alt="flag" />
            <span class="mt-2">{{ lang.name }}</span>
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    textWhite: {
      type: String,
    },
  },
  data() {
    return {
      showLanguageBar: false,
      selectedLanguage: this.$i18n.locale,
      languages: [
        { code: "sr", name: "Srpski", flag: "https://flagcdn.com/rs.svg" },
        { code: "en", name: "English", flag: "https://flagcdn.com/gb.svg" },
        //{ code: "fr", name: "French", flag: "https://flagcdn.com/fr.svg" },
      ],
    };
  },
  methods: {
    changeLanguage(code) {
      this.$i18n.locale = code;
    },
    findLanguageByCode(code) {
      return this.languages.find((language) => language.code === code);
    },
  },
};
</script>

<style scoped>
.flag {
  width: 20px;
  height: 15px;
  margin-right: 8px;
  vertical-align: middle;
}
.bord {
  border-radius: 7px;
  border: 1px solid #e6e6e6;
  background-color: rgb(242, 242, 242);
}
.shad {
  box-shadow: 0px 7px 8px rgb(212, 211, 211);
}
</style>
